import { getClient } from '@/lib/restClient';
import { StoreManagementBrandService } from '@/services/StoreManagement/Brands/StoreManagementBrandService';

export type StoreManagementAssociateBrandCreateParams = {
  name: string;
};

export type StoreManagementAssociateBrandCreateResponse = {
  id: number;
  name: string;
};

export const useStoreManagementAssociateBrandCreate = async (
  params: StoreManagementAssociateBrandCreateParams
): Promise<StoreManagementAssociateBrandCreateResponse> => {
  const storeManagementBrandService = new StoreManagementBrandService(
    getClient()
  );
  return await storeManagementBrandService.create(params);
};
